import { sample } from 'lodash'
import { IWhitelabelContext } from 'main/framework'
import { AssetName } from 'main/util/asset'

const DEFAULT_IMAGE_URL = [
  'd966d9da-7e28-4860-8b00-959013fadc52',
  '09de0125-80c5-41d7-955c-54e2b98cd714',
  '81d3df64-e7b5-4c4b-bee4-eb84829e71af',
  'eb446b94-2edb-4c0b-9717-f71f19f71873',
  'e51e44a7-6a51-47f7-a690-64d8e85c7560',
  'f0d6d768-d81d-46b0-b7d9-6db8ffeed624',
  '5753da24-3010-4e1b-b0ad-4ef56f1794c4',
  '23a6e2d0-1819-432e-9e9a-292c3a842a5e',
  '6a5b4246-b871-44c9-9096-58a6f74e456e',
  'eac7b076-6883-41c3-a162-0262d503f14c',
  '25cfcd79-f953-4242-86e4-e742e553e4ef',
  '7259b237-5bc0-4ca8-92c4-18d54ad5db4f',
  'ff4111be-1035-4f55-a409-0a725071888e',
  '78e6831d-28dc-4430-95c2-29fabe26fafb',
  'e1f31c03-3716-4867-aa1f-5bfb7822e182',
  '808abb39-3d38-4ffc-92ef-27b7b8e82917',
  'dc6dbcb2-a531-43ab-a409-cf991bac08d4',
  '75c61371-dcc8-4021-b127-2a81e741dc4b',
  '4c9c157b-60d6-4e82-9585-22f36b5703a8',
  'dbabfb0b-d9dd-4da6-834f-6fcf634964ac',
  'dbf70587-8d6d-4edd-ab49-86c204cbeeaa',
  'cca712d0-2f44-4123-9bc8-6a787106c687',
  'ecfb44a6-6a48-41ad-b4fb-4f7820642a79',
  '5e520fcd-9f3d-4a1d-bd9c-97904a69d9e7',
  'f66514c3-8e71-4387-ae0f-ee51f312db64',
  '93eb9700-145a-4627-9e04-b9c787f746a6',
  '41ddf539-013d-4a1a-bf9a-55ed5e7d2dd3',
  '74f81e78-22ca-4b0d-8c3e-15ed03f5d303',
  'f00f4d46-2d37-4709-9234-a221e00bb0b8',
  '4c6d0ff4-374b-4ef4-95c1-5cd8985454e1',
  '2f8a5b91-8195-47f3-9c2b-764ab64b780a',
  '9b574252-d978-4c6d-aec3-6dee563259dc',
  '585fc2fc-bd9b-45ea-bc13-b41f251e3b87',
  '6f184906-dc31-4a63-a49b-81663fe68b82',
  'f563c6b4-c31c-45ea-9a9f-a465b8eb5c90',
  '1d62be5d-3312-4d30-ba4a-60774e566e9b',
  '5a7f5eb3-2bf9-46ea-906a-53aa7d390f7d',
  '7f0a0610-1b4e-4413-970e-30c3964da4bb',
  'f2e22032-c142-49c9-b102-b332908370d0',
  '2142dc7e-ae97-49d4-95b3-62fd1d3e49ba',
  'c526b6f6-8170-4192-badd-d621eb483308',
  '8d537d1f-c9fa-4424-9367-46523e9267da',
  '9e40155c-0537-49ff-9f45-07451d151950',
  '9c5e9bc2-2c57-4563-b5a8-5b80d8fa9b8d',
  'fb440057-fe1e-44e0-a12b-b709357b8b93',
  '24855ee7-1404-441b-9e10-0af1f34557b4',
  '1f42ac59-1e59-4372-9919-c939aac8db2d',
  '6d3c7473-1d04-48bb-b8f7-54e11aca7f39',
  'eacf1eee-3fd9-4cd2-a8c7-e9cc97f42ee3',
  '87daf591-6eb7-442c-b6b3-40faf6829cb3',
  '9a748d8f-67a0-41c4-980d-5ccc3721a444',
  '91bb8bd4-f0d5-4ec0-85b7-a8c0d636ea40',
  '934b7f6f-0e0f-4323-8191-e02212a5cec7',
  'c37482e5-ff60-4062-a462-19a92a7a1452',
  '9ab877bb-95e7-4b33-a8ca-1a329100020c',
  'f0ec5cf0-5d4a-49d1-80c6-ec8bd5dce676',
  'ebeceb21-396b-495e-8585-e473a8fcd1e8',
  '67176762-daf9-4d1e-9cd0-a4a2e4a8fc99',
  '5f26314b-aa89-45ec-8f38-8469f434d35e',
  '443ad5e7-5ddc-4342-b1c5-bc838afa7c20',
  'd35496eb-9d3a-48ac-946c-6354f93e3cd2',
  '79057336-cad6-40ce-8445-275b3211a935',
]

const NEW_MEXICO_DEFAULT_IMAGE_URLS = [
  'https://ucarecdn.com/9cdea518-7eb5-427f-9a8c-7bf993761797/',
  'https://ucarecdn.com/6b8bce8d-dfcf-431c-a5d1-11bffd70c6dd/',
  'https://ucarecdn.com/290ae029-cbb0-47b9-91e4-9c311c8a7afc/',
  'https://ucarecdn.com/97bfb127-9364-4249-8e86-5cc17f81a603/',
]

export function stockImageFromId(schoolId: number) {
  const randomIndex = schoolId % DEFAULT_IMAGE_URL.length
  const randomImage = DEFAULT_IMAGE_URL[randomIndex]
  return `https://ucarecdn.com/${randomImage}`
}

/*
 * If internal school, use the passed in image
 * otherwise, it's off platform.
 *   - prefer white labeled image
 *   - oherwise use the image passed in for off-platform schools
 *   - otherwise use a stock image
 *
 * */
export function determineImage(
  internal: boolean,
  schoolId: number | undefined | null,
  whitelabel: IWhitelabelContext,
  image: string | null,
): string {
  let candidate = onPlatformSchoolImage(internal, image)
  if (!candidate) candidate = whitelabeledImage(whitelabel)
  if (!candidate) candidate = image
  if (!candidate) candidate = stockImageFromId(schoolId || 0)

  return trimTrailingSlash(candidate)
}

function onPlatformSchoolImage(internal: boolean, image: string | null): string | null | undefined {
  return internal ? image : undefined
}

function whitelabeledImage(whitelabel: IWhitelabelContext): string | undefined {
  switch (whitelabel.getAsset(AssetName.NETWORK_ABBR)) {
    case 'ELI':
      return whitelabel.getAsset(AssetName.DEFAULT_HEADER__OFF_PLATFORM)
    case 'NM':
      return sample(NEW_MEXICO_DEFAULT_IMAGE_URLS)
    default:
      return undefined
  }
}

function trimTrailingSlash(str: string): string {
  return str.replace(/\/+$/, '')
}
